module.exports = __webpack_public_path__ + "static/media/service2.77dca747.png";